function MahakTable() {
  return (
    <table className='my-8 mx-auto w-full max-w-xl table-auto border-collapse border border-blue-400 text-center'>
      <thead className='bg-blue-200'>
        <tr>
          <th className='border border-blue-400 p-1 xs:p-3'>درصد کسب شده در آزمون محک</th>
          <th className='border border-blue-400 p-1 xs:p-3'>میزان تخفیف برای آزمون‌های زمستان</th>
        </tr>
      </thead>
      <tbody className='font-medium'>
        <tr>
          <td className='border border-blue-400 p-1 xs:p-3'>بیشتر از 80 درصد</td>
          <td className='border border-blue-400 p-1 xs:p-3'>۱۰۰٪ بورسیه (کاملاً رایگان)</td>
        </tr>
        <tr className='bg-blue-50'>
          <td className='border border-blue-400 p-1 xs:p-3'>20 تا 80 درصد</td>
          <td className='border border-blue-400 p-1 xs:p-3'>تخفیف متناسب با درصد کسب شده</td>
        </tr>
        <tr>
          <td className='border border-blue-400 p-1 text-center xs:p-3'>کمتر از 20 درصد</td>
          <td className='border border-blue-400 p-1 text-center xs:p-3'>۲۰٪ تخفیف ثابت</td>
        </tr>
      </tbody>
    </table>
  );
}

export default MahakTable;
